<template>
	<!-- Digital Wallets Summary -->
	<!-- Enable this down the road when we're ready to adjust shipping options from the APM pay sheets -->
	<!-- v-if="!this.store.user.id" -->
	<div class="mt-4">
		<div class="w-full flex flex-col items-center">
			<!-- <div class="flex text-start text-base text-ihh-midnight-gray mb-4 w-full">Check out faster with:</div> -->
			<div class="flex flex-col items-center md:items-start w-full gap-y-2 max-w-[350px] md:max-w-[350px]">
				<!-- PayPal Row (Full Width on md+) -->
				<div class="w-80 md:w-full">
					<PayPalButton :layout="column" />
				</div>

				<!-- Other Payment Methods Row -->
				<div class="flex flex-col gap-y-2 w-80 md:w-full md:gap-x-2">
					<!-- Venmo Button -->
					<div v-if="showVenmo" class="w-full md:flex-1">
						<VenmoButton :isVenmoCheckout="true" @updateShowVenmo="handleVenmoAvailability" />
					</div>

					<!-- Apple Pay -->
					<div class="w-full md:flex-1" :class="[!showApplePay ? 'hidden' : '']">
						<ApplePayButton @updateAvailability="handleAppleAvailability" />
					</div>

					<!-- Google Pay -->
					<div class="w-full md:flex-1" :class="[!showGooglePay ? 'hidden' : '']">
						<GooglePayButton @updateAvailability="handleGoogleAvailability" />
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="flex items-center justify-between truncate w-full py-4">
		<div class="border-b border-solid border-ihh-gray/40 rounded-l-full flex-grow min-w-[1rem] md:min-w-[2rem] shrink-0" />
		<div class="text-xs md:text-sm text-ihh-midnight-gray mx-2 md:mx-4">OR</div>
		<div class="border-b border-solid border-ihh-gray/40 rounded-r-full flex-grow min-w-[1rem] md:min-w-[2rem] shrink-0" />
	</div>
</template>

<script>
import PayPalButton from './paypal-button.vue'
import VenmoButton from './venmo-button.vue'
import ApplePayButton from './apple-pay-button.vue'
import GooglePayButton from './google-pay-button.vue'
import { useCheckoutStore } from '../../stores/store.js'

export default {
	name: 'DigitalWallets',
	inject: ['store'],
	components: { PayPalButton, VenmoButton, ApplePayButton, GooglePayButton },
	data() {
		return {
			checkout: useCheckoutStore(),
			windowWidth: window.innerWidth,
			showApplePay: true,
			showVenmo: true,
			showGooglePay: true,
		}
	},
	computed: {
		paypalLayout() {
			return this.windowWidth >= 768 ? 'row' : 'column'
		},
		hideWallets() {
			if ((this.checkout.giftCertificateAmount > 0 || this.checkout.storeCredit > 0) && this.checkout.remainingBalance - this.checkout.shippingTotal <= 0) {
				return true
			}
			return false
		},
	},
	methods: {
		updateWidth() {
			this.windowWidth = window.innerWidth
		},
		handleAppleAvailability(value) {
			this.showApplePay = value
		},
		handleVenmoAvailability(value) {
			this.showVenmo = value
		},
		handleGoogleAvailability(value) {
			this.showGooglePay = value
		},
	},
	mounted() {
		window.addEventListener('resize', this.updateWidth)
	},
	unmounted() {
		window.removeEventListener('resize', this.updateWidth)
	},
}
</script>

<style scoped></style>
